import { useEffect } from "react";

export default function createExternalRedirect(to: string) {
  const ExternalRedirect = () => {
    useEffect(() => {
      if (typeof window !== "undefined") {
        window.location.replace(to);
      }
    }, []);
    return null;
  };
  return ExternalRedirect;
}
